import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { hasProperty } from '@/constants/routesLimited.js'
import { useGetStore } from '@/composables/useGetStore'

const { getStore } = useGetStore()

export function useHasProperty({
	store,
	getter,
	property,
	value,
}: {
	store: any
	getter: string
	property: string
	value: unknown
}) {
	const activeStore = getStore(store)
	const storeRefs = storeToRefs(activeStore)
	const storeValue = storeRefs[getter]
	return computed(() => {
		const data = storeValue.value
		return hasProperty(data, property, value)
	})
}
